'use client'

import { useEffect, useState } from 'react'

import { analytics } from '@/lib/analytics'
import { trackSessionIdentified } from '@/lib/analytics/events'
import type { Tenant } from '@/services/http/tenantService/types'
import type { User } from '@/services/http/usersService/types'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

export function IdentifierUser({ user }: { user?: User }) {
  const [tenant, setTenant] = useState<Tenant | null>(null)

  useEffect(() => {
    getTenantByCookies().then(setTenant)
  }, [])

  useEffect(() => {
    if (!user || !user.email || !tenant) return

    analytics.identify(user.id, {
      email: user.email,
      name: user.name,
      avatar: user.profilePhoto || '',
      tenantId: tenant.id,
      tenantName: tenant.name,
      tenantSlug: tenant.slug,
      tenantStatus: tenant.status,
      role: user.role,
      area: user.area?.name || '',
      isAdmin: user.isAdmin,
      isManager: user.isManager,
      domain: window.location.origin,
      userAgent: navigator.userAgent,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })

    trackSessionIdentified({
      userId: user.id,
      tenantId: tenant.id,
      tenantSlug: tenant.slug,
      role: user.role,
      timestamp: new Date().toISOString(),
    })
  }, [user, tenant])

  return null
}
